module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueParcours_LRP_disabled.b1d49c7e.png";